import { AreaCrumbs, AreaSwitcher, AreaTabs, useAreaHeader } from '@/shared/navigation';

/**
 * Schmale Kopfleiste für Seiten, die (noch) keinen Bereichskopf rendern – Heute, Buchung,
 * Reinigung, Haus, Apartment, Benutzer, Nachrichten. So zeigt jede Seite Pfad und Bereich, bis
 * ihr Inhalt im neuen Design umgebaut ist.
 */
export function AreaFallbackHeader() {
  const area = useAreaHeader();
  if (area.headers > 0) return null;
  if (area.crumbs.length === 0 && area.switcher.length < 2 && area.tabs.length < 2) return null;
  return (
    <div className="on-forest bg-forest-deep rounded-hero mb-5 flex flex-none flex-col gap-3 px-5 py-3.5 text-white md:px-6">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <AreaCrumbs crumbs={area.crumbs} />
        <AreaSwitcher items={area.switcher} />
      </div>
      <AreaTabs tabs={area.tabs} />
    </div>
  );
}
